import { createActionGroup, props } from '@ngrx/store';
import { AnalyticsPageViewEvent } from '../../services/analytics';

export const AnalyticsActions = createActionGroup({
  source: 'Analytics',
  events: {
    'Viewed Page': props<{ eventParams: AnalyticsPageViewEvent['eventParams'] }>(),
  },
});
